/*
 *  -----------------------------------------------------------------------
 *    <copyright file="assign-svt-assessment.data.ts" company="Triumph Research Intelligence">
 *        Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import { LibraryGridColumn } from '@components/admin/library-grid/library-grid.interface';
import { useGridCells } from '@hooks/index';

const { MaxLengthCell } = useGridCells();
export const ASSIGN_SVT_ASSESSMENT_COLUMNS = (translate: Function): LibraryGridColumn[] => [
    {
        title: translate('admin:attributes'),
        id: 'item-attributes',
        field: '_attributes',
        cells: { data: MaxLengthCell(150) },
    },
    {
        title: translate('name'),
        id: 'item-name',
        field: 'name',
        cells: { data: MaxLengthCell(150) },
    },
];
